import { entity } from "./Connection"
import { noteFolds } from "./Folds"

export const NoteEntity = entity("Note", { folds: noteFolds });
